export default __webpack_public_path__ + "static/media/creatachainlogo.f58b89f7.svg";